import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-spiritual-800 to-spiritual-900 text-white py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-divine-400 rounded-full flex items-center justify-center">
                <span className="text-spiritual-800 font-bold text-xl">D</span>
              </div>
              <span className="text-2xl font-bold">DivyaTemple</span>
            </div>
            <p className="text-spiritual-200 mb-6">
              Your comprehensive guide to exploring India's sacred temples and planning pilgrimages.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-white hover:text-divine-300 transition-colors">
                <span className="sr-only">Facebook</span>
                <span className="text-2xl">📱</span>
              </a>
              <a href="#" className="text-white hover:text-divine-300 transition-colors">
                <span className="sr-only">Twitter</span>
                <span className="text-2xl">📱</span>
              </a>
              <a href="#" className="text-white hover:text-divine-300 transition-colors">
                <span className="sr-only">Instagram</span>
                <span className="text-2xl">📱</span>
              </a>
              <a href="#" className="text-white hover:text-divine-300 transition-colors">
                <span className="sr-only">YouTube</span>
                <span className="text-2xl">📱</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="hover:text-divine-300 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/temple" className="hover:text-divine-300 transition-colors">
                  Temples
                </Link>
              </li>
              <li>
                <Link to="/#pilgrimage" className="hover:text-divine-300 transition-colors">
                  Pilgrimage
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-divine-300 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-divine-300 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Temple Categories</h4>
            <ul className="space-y-2">
              <li>
                <Link to="#" className="hover:text-divine-300 transition-colors">
                  Shiva Temples
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-divine-300 transition-colors">
                  Vishnu Temples
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-divine-300 transition-colors">
                  Devi Temples
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-divine-300 transition-colors">
                  Ganesha Temples
                </Link>
              </li>
              <li>
                <Link to="#" className="hover:text-divine-300 transition-colors">
                  Jyotirlingas
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="mr-2">📍</span>
                <span>123 Temple Street, New Delhi, India</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">📞</span>
                <span>+91 98765 43210</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">✉️</span>
                <span>info@divyatemple.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-spiritual-700 mt-12 pt-6 text-center text-spiritual-300">
          <p>&copy; {new Date().getFullYear()} DivyaTemple. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer